export default __webpack_public_path__ + "static/media/right-arrow2.33fa0475.png";